import React from 'react';
import { Box, TextV2 as Text } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export interface FilterFacetProps {
  title: string;
  description?: string;
  children: React.ReactNode;
}

export const FilterFacet: React.FC<FilterFacetProps> = ({ title, description, children }) => {
  return (
    <Box>
      <Text
        typographyVariant="hed2"
        marginBottom={description ? 2 : pxToRem(20)}
      >
        {title}
      </Text>
      {description && (
        <Text
          typographyVariant="body1"
          color="mono10"
          marginBottom={pxToRem(24)}
        >
          {description}
        </Text>
      )}
      {children}
    </Box>
  );
};
